
  import Vue from "vue";
  import Component from "vue-class-component";

  @Component
  export default class Payroll extends Vue {
    mounted () {
      window.addEventListener("dragenter", (e) => {
        this.showDropZone();
      });

      window.addEventListener("dragleave", (e) => {
        e.preventDefault();
        this.hideDropZone();
      });

      window.addEventListener("dragover", (e) => {
        e.preventDefault();
        this.showDropZone();
      });

      window.addEventListener("drop", (e) => {
        e.preventDefault();
        this.hideDropZone();

        this.onDrop(e);
      });
    }

    showDropZone () {
      // @ts-ignore
      document.querySelector(".dropzone").style.visibility = "";
      // @ts-ignore
      document.querySelector(".dropzone").style.opacity = 1;
      // @ts-ignore
      document.querySelector(".dropzone-text").style.fontSize = "48px";
    }

    hideDropZone () {
      // @ts-ignore
      document.querySelector(".dropzone").style.visibility = "hidden";
      // @ts-ignore
      document.querySelector(".dropzone").style.opacity = 0;
      // @ts-ignore
      document.querySelector(".dropzone-text").style.fontSize = "42px";
    }

    onDrop (event: DragEvent) {
      this.$emit("drop", event);
    }
  }
